import styled from 'styled-components';

import {
  fontFamilySecondary,
  colorBlack900,
  colorGrey400,
  mediaQueryMobileLargeMin,
  colorAccent50,
} from 'styles';

import Icon from 'components/commons/Icon';
import { H2, ParagraphSmall, Paragraph } from 'components/Typography';
import { CommentsLink } from 'components/ExchangeDiscussion/styles';

export const Wrapper = styled.div`
  margin-top: 16px;

  @media all and ${mediaQueryMobileLargeMin} {
    margin-top: 24px;
  }
`;

export const IconWatch = styled(Icon)`
  margin-right: 4px;
  margin-top: -1px;
`;

export const ExchangerLink = styled.a`
  font-size: 14px;
  line-height: 18px;
  display: flex;
  min-height: 40px;
  justify-content: center;
  align-items: center;

  &:hover {
    opacity: 0.8;
  }

  & > svg {
    color: #87928c;
  }
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  font-family: ${fontFamilySecondary};
  margin-bottom: 16px;

  & > ul {
    margin-left: unset;
  }

  & > ul button svg {
    margin-top: 1px;
  }

  @media all and ${mediaQueryMobileLargeMin} {
    flex-direction: row;

    & > ul {
      margin-left: auto;
      width: unset;
    }
  }
`;

export const Title = styled(H2)`
  color: ${colorBlack900};
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  margin-bottom: 16px;
  font-family: ${fontFamilySecondary};

  @media all and ${mediaQueryMobileLargeMin} {
    font-size: 20px;
    line-height: 28px;
    margin-bottom: 0;
  }
`;
export const CurrencySelectWrapper = styled.div`
  height: 48px;
  display: flex;
  align-items: center;

  @media all and ${mediaQueryMobileLargeMin} {
    height: auto;
    display: block;
  }
`;
export const TableHead = styled.thead`
  & tr {
    box-shadow: none;
    background-color: transparent !important;

    &:last-child {
      display: none;
      @media all and ${mediaQueryMobileLargeMin} {
        display: table-row;
      }
    }
  }
`;

export const TableTitle = styled.th`
  color: ${colorGrey400};
  font-weight: normal;
  font-size: 13px;
  line-height: 16px;
  text-align: center;

  &:last-of-type {
    width: 40px;
  }
  div {
    text-align: right;
  }
`;

export const TableTitleContent = styled.div`
  display: flex;
  padding: 16px 8px;
  color: ${colorGrey400};
  justify-content: ${({ align }) =>
    align === 'left' ? 'flex-start' : 'center'};
  align-items: center;

  @media all and ${mediaQueryMobileLargeMin} {
    padding: 8px 16px;
  }
  &#publish {
    justify-content: flex-end;
  }
`;

export const ExchangersList = styled.table`
  width: 100%;

  & td:last-child {
    width: 50px !important;
    padding: 0;
    text-align: center;
    vertical-align: middle;
    margin-left: auto;
  }
`;

export const Row = styled.tr`
  box-shadow: inset 0 1px 0 #e6e6e6;
  display: flex;
  flex-wrap: wrap;
  padding: 16px 0;

  &:nth-of-type(odd) {
    background-color: #fbfbfb;
  }

  & td:last-child {
    width: 100%;
    padding: 0;
    justify-content: flex-end;
  }

  @media all and ${mediaQueryMobileLargeMin} {
    display: table-row;
  }

  ${({ $clickable }) =>
    $clickable &&
    `
    cursor: pointer;

    &:hover {
      opacity: 0.8;
    }
  `}

  ${({ commercialPlacement }) => {
    if (commercialPlacement) {
      return `
            background-color: #FEF9E9 !important;
            `;
    }

    return ``;
  }};
`;

export const Column = styled.td`
  padding: 0 16px;
  font-size: 14px;
  line-height: 24px;
  color: #696f6b !important;
  vertical-align: middle;

  @media all and ${mediaQueryMobileLargeMin} {
    padding: 16px;
    vertical-align: middle;
    &:last-child {
      width: 40px;
    }
  }
`;

export const ColumnAddress = styled(Column)`
  max-width: 80%;
  margin-bottom: 4px;

  @media all and ${mediaQueryMobileLargeMin} {
    margin-bottom: 0;
  }
`;

export const ColumnUpdate = styled(Column)`
  padding: 0 16px;
  order: 9;
  width: 100%;
  @media all and ${mediaQueryMobileLargeMin} {
    padding: 16px;
    margin-top: 0;
    width: auto;
  }
`;

export const Update = styled.div`
  color: ${colorGrey400};
  font-size: 13px;
  line-height: 19px;
  white-space: nowrap;
  align-items: center;
  display: flex;

  @media all and ${mediaQueryMobileLargeMin} {
    justify-content: flex-end;
  }
`;

export const CurrContent = styled.div`
  display: flex;
  font-size: 16px;
  line-height: 18px;
  height: 100%;
  font-weight: 700;
  color: ${colorBlack900};

  @media all and ${mediaQueryMobileLargeMin} {
    font-size: 16px;
    line-height: 18px;
  }
`;
export const Rates = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
  margin-bottom: 8px;
  @media all and ${mediaQueryMobileLargeMin} {
    flex-direction: column;
    align-items: flex-start;
    gap: 3px;
    margin-bottom: 0px;
  }
`;
export const Amount = styled.div`
  white-space: nowrap;
`;

export const DiffWrapper = styled.div`
  display: flex;
  align-items: flex-end;
  height: 14px;

  @media all and ${mediaQueryMobileLargeMin} {
    height: unset;
  }
`;

export const Diff = styled(ParagraphSmall)`
  font-weight: normal;
  margin-top: 7px;
`;

export const IconWrapper = styled.div`
  margin: 0 2px 0 4px;
  padding-top: 2px;
`;

export const AllBanks = styled(CommentsLink)`
  margin-top: 0;
  order: 2;

  @media all and ${mediaQueryMobileLargeMin} {
    order: 1;
  }
`;

export const Source = styled(Paragraph)`
  color: ${colorGrey400};
  line-height: 16px;
  order: 1;

  @media all and ${mediaQueryMobileLargeMin} {
    order: 2;
  }
`;

export const Disclaimer = styled.div`
  order: 3;
  display: flex;
  gap: 12px;
  background-color: ${colorAccent50};
  padding: 16px;
  font-size: 14px;
  line-height: 18px;

  @media all and ${mediaQueryMobileLargeMin} {
    width: 100%;
  }
`;

export const DisclaimerIcon = styled(Icon)`
  flex-shrink: 0;
`;

export const Bottom = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  box-shadow: inset 0px 1px 0px #e5e5e5;
  padding-top: 18px;

  @media all and ${mediaQueryMobileLargeMin} {
    flex-direction: row;
    justify-content: space-between;
    flex-wrap: wrap;
  }
`;
